import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { PRICING_URL, AUTOSPECS_TRIAL_MARKETING_URL, OFFERINGS_CATEGORIES } from './helpers/const';
import { containerStyle, textNameStyle, textExpiredStyle, buttonStyle } from './helpers/styles';
import { SUBSCRIPTION_STATUS } from '../../helpers/const';
import { subscriptionPropType } from '../../helpers/types';
const TrialModalItem = _ref => {
  let {
    userTrial
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../../i18n/".concat(locale, ".json"));
  });
  const {
    daysRemaining,
    offeringCategory,
    offeringCategoryName,
    status
  } = userTrial;
  const daysLeftText = daysRemaining > 1 ? T.translate('MODAL_ITEM_TEXT_EXPIRED_COUNT_MULTIPLE', {
    daysRemaining
  }) : T.translate('MODAL_ITEM_TEXT_EXPIRED_COUNT_SINGLE', {
    daysRemaining
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledDiv2, null, offeringCategoryName), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css: textExpiredStyle(daysRemaining)
  }, status === SUBSCRIPTION_STATUS.ACTIVE ? daysLeftText : T.translate('MODAL_ITEM_TEXT_EXPIRED'))), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "TrialModalItem_button",
    as: "a",
    target: "_blank",
    href: offeringCategory === OFFERINGS_CATEGORIES.AUTOSPECS ? AUTOSPECS_TRIAL_MARKETING_URL : "".concat(PRICING_URL, "/").concat(offeringCategory),
    style: buttonStyle,
    variant: Button.VARIANTS.PRIMARY
  }, T.translate('MODAL_ITEM_TEXT_BUTTON_TEXT')));
};
TrialModalItem.displayName = 'TrialModalItem';
TrialModalItem.propTypes = {
  /** User Trial Data */
  userTrial: subscriptionPropType.isRequired
};
export default TrialModalItem;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), containerStyle);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), textNameStyle);
var _StyledDiv3 = _styled3("div").withConfig({
  displayName: "component___StyledDiv3",
  componentId: "sc-2wcejr-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=component.js.map